// src/context/UserContext.js

import React, { createContext, useState, useEffect } from "react";
import API from "../api";

// Create the context, now including an isAdmin flag
export const UserContext = createContext({
  user: null,
  setUser: () => {},
  loading: true,
  isAdmin: false,
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Derive a boolean flag for admin privileges
  const isAdmin = Boolean(user?.is_admin);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    const validationTimeout = setTimeout(() => {
      if (cancelled) return;
      console.warn("Token validation timeout after 15s");
      setLoading(false);
    }, 15000);

    const validateToken = (retriesLeft = 1) => {
      API.get("/users/me")
        .then((res) => {
          if (cancelled) return;
          clearTimeout(validationTimeout);
          setUser(res.data);
          setLoading(false);
        })
        .catch((error) => {
          if (cancelled) return;

          const status = error.response?.status;
          if (status === 401 || status === 403) {
            clearTimeout(validationTimeout);
            setUser(null);
            localStorage.removeItem("token");
            setLoading(false);
            return;
          }

          if (retriesLeft > 0) {
            setTimeout(() => validateToken(retriesLeft - 1), 2000);
            return;
          }

          clearTimeout(validationTimeout);
          console.warn("Network/backend error during token validation; keeping session token");
          setLoading(false);
        });
    };

    validateToken(1);

    return () => {
      cancelled = true;
      clearTimeout(validationTimeout);
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        loading,
        isAdmin,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
